/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Id_LabelInputs */

const en_project_id_label = /** @type {(inputs: Project_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Id`)
};

const fr_project_id_label = /** @type {(inputs: Project_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID du projet`)
};

const de_project_id_label = /** @type {(inputs: Project_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt-ID`)
};

const it_project_id_label = /** @type {(inputs: Project_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID progetto`)
};

const ru_project_id_label = /** @type {(inputs: Project_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор проекта`)
};

const es_project_id_label = /** @type {(inputs: Project_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación del proyecto`)
};

const zh_cn2_project_id_label = /** @type {(inputs: Project_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目 ID`)
};

const ja_project_id_label = /** @type {(inputs: Project_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトID`)
};

const hi_project_id_label = /** @type {(inputs: Project_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट आईडी`)
};

const pt_pt2_project_id_label = /** @type {(inputs: Project_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do projeto`)
};

/**
* | output |
* | --- |
* | "Project Id" |
*
* @param {Project_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_id_label = /** @type {((inputs?: Project_Id_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Id_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_id_label(inputs)
	if (locale === "de") return de_project_id_label(inputs)
	if (locale === "it") return it_project_id_label(inputs)
	if (locale === "ru") return ru_project_id_label(inputs)
	if (locale === "es") return es_project_id_label(inputs)
	if (locale === "zh-CN") return zh_cn2_project_id_label(inputs)
	if (locale === "ja") return ja_project_id_label(inputs)
	if (locale === "hi") return hi_project_id_label(inputs)
	if (locale === "pt-PT") return pt_pt2_project_id_label(inputs)
	return en_project_id_label(inputs)
});